// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"47f69f62","74":"7f804e39","170":"e8761f5d","268":"1afd71d0","435":"72bd1d70","453":"3e67d583","488":"be7233a3","506":"2d2d7c7e","707":"26d75919","952":"58f83c31"}[chunkId] + ".chunk.js";
};